import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import Cabecalho from 'Component/Cabecalho';
import Icone from 'Component/Icone';
import LayoutDefault from 'Component/Layout';
import { useRecuperarTreinamentoQuery } from 'View/Service/Default/Treinamentos';

const Visualizar = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const [aulaAtiva, setAulaAtiva] = useState<number>();

  const { data: { treinamento } = {} } = useRecuperarTreinamentoQuery({
    id: id,
    contain: ['Aulas'],
  });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo={treinamento?.titulo || ''}
        descricao={treinamento?.descricao?.cortar(50)}
      />
      <div className="row">
        <div className="col-md-4">
          <div className="bg-white rounded shadow-sm p-3">
            <h4>{treinamento?.titulo}</h4>
            <div style={{ whiteSpace: 'pre-wrap' }}>
              {treinamento?.descricao}
            </div>
          </div>
        </div>
        <div className="col-md-8">
          {treinamento?.aulas?.map((aula, chave) => (
            <div key={chave.toString()} className="rounded mb-2 shadow-sm">
              <div
                className="bg-primary text-white px-3 py-2 fs-4 d-flex justify-content-between rounded cursor-pointer"
                onClick={() => setAulaAtiva(chave)}
              >
                {aula.titulo}
                <Icone nome="chevron-down" />
              </div>
              <div className={`bg-white p-3 rounded ${chave == aulaAtiva ? 'd-block' : 'd-none'}`}>
                {aula.descricao}
                {aula.url && (
                  <div className="d-block mt-3">
                    <a
                      href={aula.url}
                      className="btn btn-success"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download do arquivo
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </LayoutDefault>
  );
};

export default Visualizar;
